import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage"; 
import { getAuth } from "firebase/auth";

const firebaseConfig = {
    apiKey: "AIzaSyDNH2q9YDMvu2nSfAWg_-4yg_Bk9UrQ28o",
    authDomain: "fence-calculator-127fb.firebaseapp.com",
    databaseURL: "https://fence-calculator-127fb-default-rtdb.firebaseio.com",
    projectId: "fence-calculator-127fb",
    storageBucket: "fence-calculator-127fb.appspot.com",
    messagingSenderId: "410588364811",
    appId: "1:410588364811:web:f0eb6d0950c2624c28470e"
};

// init firebase
const app = initializeApp(firebaseConfig);

export const db = getFirestore(app);
export const storage = getStorage(app);
export const auth = getAuth();
